<template>
		<div>
			<main style='background: #EEEEEE;'>
				<div class="fyBox">
					<!-- <div class="centerBox">
						<img src="../../assets/images/shexiang_banner.png" alt="" class="topImg">
					</div> -->
				</div>
				<div class="topContent">
					<div class="centerBox">
						<p class="topContent_word1">声像资料鉴定</p>
						<p class="topContent_word2">       声像资料鉴定，是指运用物理学和计算机学的原理和技术，对录音带、录像带、磁盘、光盘、图片等载体上记录的声音、图像信息的真实性、完整性及其所反映的情况过程进行鉴定；并对记录的声音、图像中的语言、人体、物体作出种类或同一认定。</p>
					</div>
				</div>
				<div class="centerBox" style="padding:26px 0;">
					<p class="topContent_word1">鉴定机构列表</p>
					<div class="bottomContent">
						<div class="bottomContent_top">

							<a href="http://www.sfjdzx.org.cn"><img src="../../assets/images/shengxiang_logo.jpg" alt=""></a>

								<p class="bottomContent_topWord">      中经天平司法鉴定中心是经河北省司法厅核准登记设立，在中华人民共和国司法部备案，面向社会服务的电子物证司法鉴定机构。中心拥有先进的检测仪器、完善的法人管理结构及经验丰富的电子数据鉴定专家。我中心奉行“以诚为先、以专为攻、客户第一、服务至上”的执业理念，根据相关法律法规的规定和司法鉴定程序规范的要求，接受公检法机关、仲裁机构以及各企业单位、律师事务所、社会团体和当事人的委托，面向社会提供司法存证、数字资产追溯、隐私数据保护等电子数据鉴定服务。</p>
						</div>
						<div class="bottomContent_imgs">
							<img src="../../assets/images/sx_01.jpg" alt="">
							<img src="../../assets/images/sx_02.jpg" alt="">
							<img src="../../assets/images/sx_03.jpg" alt="">
							<img src="../../assets/images/sx_04.jpg" alt="">
						</div>
						<p v-for="(item, index) in jdfw" :key="index" class="fwxmItem">{{item}}</p>
						<!-- <div class="line"></div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省眼科司法医学鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省保定精神疾病司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北省张家口精神疾病司法鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北医科大学法医鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北北方学院司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								沧州市法医鉴定中心
							</p>
						</div>
						<div class="bottomWorditems">
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								衡水市法医鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								河北盛唐司法鉴定中心
							</p>
							<p class="bottomWorditem">
								<img src="../../assets/images/arrow_down.png" alt="">
								海兴司法医学鉴定中心
							</p>
						</div> -->
					</div>

				</div>
			</main>
		</div>
</template>

<script>

import axios from 'axios'
import '../../assets/css/index.less'
export default {
	name: 'Pdf',
	components: {
	},
	data() {
		return {
			jdfw:[
				'鉴定服务项目',
				'存储介质 数据固定',
				'电子数据 搜索提取',
				'网页数据获取',
				'网络数据包 获取及分析',
				'计算机系统操作行为分析'
			],
			fayuanName: '河南省高级人民法院',
			navActive: 5,
		};
	},
	methods: {
	},
	created(){

	},
	mounted() {
		let that = this;
	},
};
</script>

<style lang="less" scoped="scoped">
	.fyBox{
		width: 100%;
		height: 340px;
		box-sizing: border-box;
		background: url(../../assets/images/shexiang_banner.png)no-repeat center;

		img{
			width: 100%;
			height: 300px;
			display: block;
			margin: 0 auto;
		}
	}
	.centerBox{
		width: 1134px;
		margin: 0 auto;
		overflow: hidden;
		box-sizing: border-box;
	}
	.topContent_word1{
		// width: 66px;
		height: 30px;
		float: left;
		line-height: 30px;
		border-bottom: 4px solid  #3DADC6;
	}
	.topContent_word2{
		margin-top: 12px;
		text-indent: 30px;
		width: 100%;
		float: left;
		text-align: justify;
		font-family: PingFangRegular;
		font-size: 16px;
		color: #000000;
		text-align: left;
		line-height: 28px;
	}

	.topContent{
		width: 100%;
		background: #fff;
		padding: 26px 0;
		box-sizing: border-box;
		overflow: hidden;
	}
	.bottomContent{
		width: 100%;
		background: #fff;
		padding: 20px;
		box-sizing: border-box;
		float: left;
		margin-top: 25px;
		padding-bottom: 60px;
	}
	.bottomContent_top{
		width: 100%;
		overflow: hidden;
		display: flex;
		    align-items: center;
		    margin-bottom: 15px;
		img{
			float: left;
		}
		.bottomContent_topWord{
			float: right;
			width: calc(100% - 350px);
			font-family: PingFangRegular;
			font-size: 16px;
			color: #000000;
			text-align: left;
			line-height: 28px;
			text-indent: 30px;
			text-align: justify;

		}
	}
	.bottomContent_imgs{
		width: 100%;
		overflow: hidden;
		margin-bottom: 20px;
		img{
			width: 23%;
			display: block;
			float: left;
			margin-right: 25px;
			&:last-of-type{
				margin-right: 0;
			}
		}
	}
	.fwxmItem{
		/* width: 13%; */
		 padding: 0 10px;
		 height: 32px;
		 line-height: 32px;
		background: #3DADC6;
		 border-radius: 5px;
		 text-align: center;
		 float: left;
		 font-size: 16px;
		 color: #fff;
		 margin-right: 15px;
		 box-sizing: border-box;
		 margin-bottom: 10px;
		&:first-of-type{
			background: none;
			color: #000;
		}
		&:last-of-type{
			margin-right: 0;
		}
	}
	.line{
		width: 100%;
		border-bottom: 2px dashed  #979797;
		margin:20px 0;
		float: left;
		margin-top: 40px;
	}
	.bottomWorditems{
		width: 100%;
		border-bottom: 1px dashed  #979797;
		overflow: hidden;
		.bottomWorditem{
			width: 33%;
			height: 47px;
			line-height: 47px;
			float: left;
			display: flex;
			align-items: center;
			img{
				float: left;
				margin-right: 10px;
			}
		}
	}
</style>
